import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ZipToolsService {
  constructor(private http: HttpClient) {}

  unzipConvertAndMerge$(remoteFileId: string): Observable<Blob> {
  const url = `${environment.apiURL}/tools/zip/convert-merge`;
  return this.http.post(url, { remoteFileId }, { responseType: 'blob' });
}
}